import React, { useState, useMemo } from 'react';
import './index.less';
import { Chart, Coordinate, Axis, Interval, Tooltip } from 'bizcharts';
import { Table, Tooltip as AntTooltip } from 'antd';

import { formatPrice } from '@/common/utils';

const ListCard = (props) => {
  const dataSource = useMemo(() => getData(props.data), [props.data]);
  const columns = [
    {
      title: props.name,
      dataIndex: 'rankName',
      width: '25%',
      render: (data) => {
        return (
          <AntTooltip title={data}>
            <div className="ellipsis-2-line">{data}</div>
          </AntTooltip>
        );
      },
    },
    {
      title: '引入商详UV',
      dataIndex: 'itemUv',
      width: '30%',
      sorter: {
        compare: (a, b) => a.itemUv - b.itemUv,
      },
      render: (data) => {
        return <div>{formatPrice(data)}</div>;
      },
    },
    {
      width: '40%',
      title: '直接引导成交订单金额',
      dataIndex: 'zjOrdAmt',
      sorter: {
        compare: (a, b) => a.zjOrdAmt - b.zjOrdAmt,
      },
      render: (data) => {
        return <div>{formatPrice(data)}</div>;
      },
    },
  ];

  return (
    <div style={{ width: '33%', height: '510px', margin: '18px 0', paddingRight: '24px' }}>
      <div className="ranking-list-card">
        <div className="ranking-list-card-title">{props.title}</div>
        {dataSource && (
          <div style={{ padding: '0 20px' }}>
            <Chart data={dataSource} height={200} autoFit theme={{ maxColumnWidth: 20 }}>
              <Coordinate transpose scale={[1, -1]} />
              <Axis
                name="rankName"
                label={{
                  autoEllipsis: true,
                  autoHide: false,
                  autoRotate: false,
                }}
              />
              <Axis
                name="引入商详UV"
                grid={{
                  line: {
                    type: 'line',
                    style: {
                      stroke: '#ccc',
                      lineDash: [3, 3],
                    },
                  },
                }}
                label={null}
              />
              <Tooltip />
              <Interval position="rankName*引入商详UV" />
            </Chart>
          </div>
        )}
        <div style={{ position: 'absolute', bottom: '0', padding: '0 10px 1px 10px', height: '260px', width: '100%' }}>
          <Table columns={columns} dataSource={props.data} pagination={false} scroll={{ y: 190 }} size="small" />
        </div>
      </div>
    </div>
  );
};
function getData(data) {
  if (!data || !data.length) return;
  const res = data.slice(0, 5).map((item) => {
    return {
      rankName: item.rankName,
      引入商详UV: item.itemUv,
    };
  });
  return res;
}
export default ListCard;
